<template>
  <section class="dp-layout parking-page free-vehicle-page">
    <section class="dp-right">
      <toolbar ref="toolbar" :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <div class="parking-stat-wrap">
      <div class="parking-stat-cards" :class="{ 'is-summary-loading': summaryLoading }">
        <div class="parking-stat-card stat-total clickable" :class="{ active: searchSyncStatus === -1 }" @click="quickFilterByStatus(-1)">
          <div class="stat-card-head">
            <span class="stat-card-icon"><i class="el-icon-truck"></i></span>
            <span class="stat-card-label">总车辆</span>
          </div>
          <div class="stat-card-value">{{ summary.totalCount }}</div>
        </div>
        <div class="parking-stat-card stat-pending clickable" :class="{ active: searchSyncStatus === 0 }" @click="quickFilterByStatus(0)">
          <div class="stat-card-head">
            <span class="stat-card-icon"><i class="el-icon-upload2"></i></span>
            <span class="stat-card-label">待同步</span>
          </div>
          <div class="stat-card-value">{{ summary.pendingCount }}</div>
        </div>
        <div class="parking-stat-card stat-synced clickable" :class="{ active: searchSyncStatus === 1 }" @click="quickFilterByStatus(1)">
          <div class="stat-card-head">
            <span class="stat-card-icon"><i class="el-icon-circle-check"></i></span>
            <span class="stat-card-label">已下发</span>
          </div>
          <div class="stat-card-value">{{ summary.syncedCount }}</div>
        </div>
        <div class="parking-stat-card stat-failed clickable" :class="{ active: searchSyncStatus === 2 }" @click="quickFilterByStatus(2)">
          <div class="stat-card-head">
            <span class="stat-card-icon"><i class="el-icon-warning-outline"></i></span>
            <span class="stat-card-label">下发失败</span>
          </div>
          <div class="stat-card-value">{{ summary.failedCount }}</div>
        </div>
        <div class="parking-stat-card stat-update clickable" :class="{ active: searchSyncStatus === 3 }" @click="quickFilterByStatus(3)">
          <div class="stat-card-head">
            <span class="stat-card-icon"><i class="el-icon-edit-outline"></i></span>
            <span class="stat-card-label">待更新</span>
          </div>
          <div class="stat-card-value">{{ summary.pendingUpdateCount }}</div>
        </div>
      </div>
      </div>

      <div class="parking-table-panel">
        <div class="panel-header">
          <div class="panel-title">免费车列表<span class="count">共 {{ total }} 条</span></div>
          <div class="panel-actions">
            <el-button size="small" type="primary" plain icon="el-icon-tickets" @click="openBatchSyncJobs">下发记录</el-button>
            <el-button size="small" type="success" plain icon="el-icon-document" @click="openSchoolSyncLog">同步日志</el-button>
          </div>
        </div>

      <div class="tbl-scroll-host">
      <el-table
        :data="tableData"
        v-loading="listLoading"
        @selection-change="onSelectionChange"
        @row-click="selectCurrentRow"
        ref="table"
        class="custom-tbl"
        style="width:100%"
       height="100%">
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column prop="plateNo" label="车牌号" width="150">
          <template slot-scope="scope">
            <span class="plate-no-badge">{{ scope.row.plateNo }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ownerName" label="车主姓名" width="110">
          <template slot-scope="scope">
            <span class="owner-name-text"><i class="el-icon-user"></i> {{ scope.row.ownerName || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="手机号" width="140">
          <template slot-scope="scope">
            <span class="mobile-text" v-if="scope.row.mobile"><i class="el-icon-phone-outline"></i> {{ scope.row.mobile }}</span>
            <span v-else class="text-muted">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="sourceTypeName" label="来源" width="110">
          <template slot-scope="scope">
            <span :class="['source-tag', 'source-' + scope.row.sourceType]">{{ scope.row.sourceTypeName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="syncStatusName" label="同步状态" width="110">
          <template slot-scope="scope">
            <span :class="['sync-status-badge', 'status-' + scope.row.syncStatus]">{{ scope.row.syncStatusName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="syncError" label="失败原因" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="syncTime" label="下发时间" width="160">
          <template slot-scope="scope">
            <span class="time-text">{{ formatDate(scope.row.syncTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160">
          <template slot-scope="scope">
            <span class="time-text">{{ formatDate(scope.row.createTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right" align="center">
          <template slot-scope="scope">
            <div class="table-op-pair">
              <el-button v-if="can('openEdit')" type="text" class="table-op-link" @click.stop="openEdit(scope.row)">编辑</el-button>
              <el-button
                v-if="can('handleRetry') && (scope.row.syncStatus === 0 || scope.row.syncStatus === 2 || scope.row.syncStatus === 3)"
                type="text"
                class="table-op-link"
                @click.stop="handleRetry(scope.row)"
              >
                {{ scope.row.syncStatus === 2 ? '重试' : '同步' }}
              </el-button>
              <el-button type="text" class="table-op-link" @click.stop="openSyncLog(scope.row)">日志</el-button>
              <el-button v-if="can('handleDelete')" type="text" class="table-op-link table-op-link--danger" @click.stop="handleDelete(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <el-col :span="24" class="toolbar">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="page"
          :page-sizes="pageSizes"
          :page-size="pageSize"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          style="float:right"
        ></el-pagination>
      </el-col>
      </div>

      <!-- 新增/编辑弹窗 -->
      <el-dialog
        :title="editForm.id ? '编辑免费车' : '新增免费车'"
        :visible.sync="editFormVisible"
        :close-on-click-modal="false"
        :width="showPlateKeyboard ? '850px' : '490px'"
        custom-class="edit-vehicle-dialog"
      >
        <div class="vehicle-edit-layout">
          <div class="vehicle-edit-left">
            <el-form :model="editForm" :rules="editRules" ref="editForm" label-width="90px">
              <el-form-item label="车牌号" prop="plateNo">
                <el-input
                  v-model="editForm.plateNo"
                  placeholder="如：粤A12345"
                  style="width:100%"
                  @focus="showPlateKeyboard = true"
                  @input="syncPlateNoValidation"
                  @blur="syncPlateNoValidation"
                >
                  <i slot="suffix" class="el-icon-keyboard" style="cursor:pointer" @click="showPlateKeyboard = !showPlateKeyboard"></i>
                </el-input>
              </el-form-item>
              <el-form-item label="车主姓名">
                <el-input v-model="editForm.ownerName" placeholder="可选"></el-input>
              </el-form-item>
              <el-form-item label="手机号">
                <el-input v-model="editForm.mobile" placeholder="可选"></el-input>
              </el-form-item>
              <el-form-item label="是否长期">
                <el-switch v-model="editForm.endTypeLong" active-text="长期" inactive-text="限期"></el-switch>
              </el-form-item>
              <el-form-item v-if="!editForm.endTypeLong" label="开始时间">
                <el-date-picker v-model="editForm.bTime" type="datetime" placeholder="选择开始时间"
                  value-format="yyyy-MM-dd HH:mm:ss" style="width:100%"></el-date-picker>
              </el-form-item>
              <el-form-item v-if="!editForm.endTypeLong" label="结束时间">
                <el-date-picker v-model="editForm.eTime" type="datetime" placeholder="选择结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss" style="width:100%"></el-date-picker>
              </el-form-item>
            </el-form>
          </div>
          <div v-if="showPlateKeyboard" class="vehicle-edit-right">
            <div class="plate-keyboard-wrap">
              <plate-keyboard
                v-model="editForm.plateNo"
                @input="syncPlateNoValidation"
              ></plate-keyboard>
            </div>
          </div>
        </div>
        <div slot="footer">
          <el-button @click="editFormVisible = false">取消</el-button>
          <el-button type="primary" :loading="editSaving" @click="submitEdit">保存</el-button>
        </div>
      </el-dialog>

      <!-- 批量下发任务记录 -->
      <el-dialog
        title="下发记录"
        :visible.sync="batchSyncJobVisible"
        width="900px"
        custom-class="batch-sync-job-dialog"
        :close-on-click-modal="false"
        @open="onBatchSyncJobDialogOpen"
        @close="stopBatchSyncPolling"
      >
        <el-alert
          v-if="activeBatchSyncJob"
          type="info"
          :closable="false"
          show-icon
          style="margin-bottom:10px"
          :title="`进行中：${activeBatchSyncJob.sourceName || '批量下发'} — 成功 ${activeBatchSyncJob.successCount} / 失败 ${activeBatchSyncJob.failCount} / 共 ${activeBatchSyncJob.totalCount}`"
        ></el-alert>
        <el-table :data="batchSyncJobList" v-loading="batchSyncJobLoading" size="small" max-height="360">
          <el-table-column prop="startTime" label="开始时间" width="160">
            <template slot-scope="scope">{{ formatDate(scope.row.startTime) }}</template>
          </el-table-column>
          <el-table-column prop="sourceName" label="来源" width="120"></el-table-column>
          <el-table-column prop="operatorName" label="操作人" width="90"></el-table-column>
          <el-table-column label="进度" min-width="160">
            <template slot-scope="scope">
              成功 {{ scope.row.successCount }} / 失败 {{ scope.row.failCount }} / 共 {{ scope.row.totalCount }}
            </template>
          </el-table-column>
          <el-table-column label="状态" width="80">
            <template slot-scope="scope">
              <el-tag size="mini" :type="scope.row.status === 0 ? 'warning' : 'success'">
                {{ scope.row.statusName || (scope.row.status === 0 ? '进行中' : '已完成') }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="明细" width="70">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="openBatchSyncJobDetail(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-right">
          <el-pagination
            layout="total, sizes, prev, pager, next, jumper"
            :total="batchSyncJobTotal"
            :page-sizes="pageSizes"
            :page-size="batchSyncJobPageSize"
            :current-page.sync="batchSyncJobPage"
            @size-change="handleBatchSyncJobSizeChange"
            @current-change="loadBatchSyncJobList"
          ></el-pagination>
        </div>
        <div slot="footer">
          <el-button @click="batchSyncJobVisible = false">关闭</el-button>
        </div>
      </el-dialog>

      <!-- 批量下发任务明细 -->
      <el-dialog
        :title="batchSyncJobDetailTitle"
        :visible.sync="batchSyncJobDetailVisible"
        width="760px"
        append-to-body
        :close-on-click-modal="false"
        @open="loadBatchSyncJobItems"
      >
        <el-table :data="batchSyncJobItemList" v-loading="batchSyncJobItemLoading" size="small" max-height="380">
          <el-table-column prop="plateNo" label="车牌号" width="120"></el-table-column>
          <el-table-column prop="operateTypeName" label="操作" width="70"></el-table-column>
          <el-table-column label="状态" width="80">
            <template slot-scope="scope">
              <el-tag size="mini" :type="scope.row.processStatus === 1 ? 'success' : (scope.row.processStatus === 2 ? 'danger' : 'info')">
                {{ scope.row.processStatusName }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="resultMessage" label="说明" min-width="140" show-overflow-tooltip></el-table-column>
          <el-table-column prop="finishedTime" label="完成时间" width="160">
            <template slot-scope="scope">{{ formatDate(scope.row.finishedTime) }}</template>
          </el-table-column>
        </el-table>
        <el-pagination
          layout="total, prev, pager, next"
          :total="batchSyncJobItemTotal"
          :page-size="batchSyncJobItemPageSize"
          :current-page.sync="batchSyncJobItemPage"
          @current-change="loadBatchSyncJobItems"
          class="pagination-right"
        ></el-pagination>
      </el-dialog>

      <!-- 同步日志弹窗 -->
      <el-dialog
        :title="syncLogVehiclePlate ? `同步日志 - ${syncLogVehiclePlate}` : '同步日志'"
        :visible.sync="syncLogVisible"
        width="860px"
        custom-class="sync-log-dialog"
        :close-on-click-modal="false"
        @open="loadSyncLogList"
      >
        <div
          class="sync-log-body"
          v-loading="syncLogExportLoading"
          element-loading-text="正在导出日志，请稍候..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255, 255, 255, 0.78)"
        >
        <div class="toolbar-filter-bar toolbar-filter-bar--embed">
          <el-form :inline="true" class="toolbar-filter-form" @submit.native.prevent="handleSyncLogSearch">
            <div class="toolbar-filter-fields">
              <el-form-item label="车牌号">
                <el-input
                  v-model="syncLogSearchPlateNo"
                  placeholder="车牌号"
                  clearable
                  class="toolbar-field-w-md"
                  @keyup.enter.native="handleSyncLogSearch"
                ></el-input>
              </el-form-item>
              <el-form-item label="操作">
                <el-select v-model="syncLogSearchOperateType" placeholder="全部" class="toolbar-field-w-sm">
                  <el-option :value="-1" label="全部"></el-option>
                  <el-option :value="1" label="新增"></el-option>
                  <el-option :value="2" label="编辑"></el-option>
                  <el-option :value="3" label="删除"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="结果">
                <el-select v-model="syncLogSearchIsSuccess" placeholder="全部" class="toolbar-field-w-sm">
                  <el-option :value="-1" label="全部"></el-option>
                  <el-option :value="1" label="成功"></el-option>
                  <el-option :value="0" label="失败"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" icon="el-icon-search" @click="handleSyncLogSearch">查询</el-button>
                <el-button type="info" size="small" icon="el-icon-refresh-left" @click="resetSyncLogSearch">重置</el-button>
              </el-form-item>
            </div>
            <div class="toolbar-filter-actions">
              <el-button type="warning" size="small" icon="el-icon-download" :loading="syncLogExportLoading" @click="handleExportSyncLog">导出日志</el-button>
            </div>
          </el-form>
        </div>
        <el-table :data="syncLogList" v-loading="syncLogLoading" size="small" max-height="420" style="width:100%">
          <el-table-column prop="createTime" label="时间" width="160">
            <template slot-scope="scope">{{ formatDate(scope.row.createTime) }}</template>
          </el-table-column>
          <el-table-column label="操作" width="80" align="center">
            <template slot-scope="scope">
              <el-tag size="mini" effect="plain" :type="syncLogOperateTagType(scope.row.operateType)">
                {{ scope.row.operateTypeName || '-' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="plateNo" label="车牌号" width="150"></el-table-column>
          <el-table-column label="结果" width="80">
            <template slot-scope="scope">
              <el-tag size="mini" :type="scope.row.isSuccess ? 'success' : 'danger'">
                {{ scope.row.isSuccess ? '成功' : '失败' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="errMsg" label="说明" min-width="140" show-overflow-tooltip></el-table-column>
          <el-table-column label="详情" width="70">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="openSyncLogDetail(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-right">
          <el-pagination
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="syncLogPage"
            :page-sizes="pageSizes"
            :page-size="syncLogPageSize"
            :total="syncLogTotal"
            @size-change="handleSyncLogSizeChange"
            @current-change="handleSyncLogPageChange"
          ></el-pagination>
        </div>
        </div>
        <div slot="footer">
          <el-button @click="syncLogVisible = false">关闭</el-button>
        </div>
      </el-dialog>

      <!-- 同步日志响应详情 -->
      <el-dialog
        :visible.sync="syncLogDetailVisible"
        width="520px"
        append-to-body
        :close-on-click-modal="false"
        custom-class="sync-log-detail-dialog"
      >
        <div slot="title" class="sync-log-detail-title">
          <span>下发详情</span>
          <el-tag v-if="syncLogDetail" size="small" :type="syncLogDetail.isSuccess ? 'success' : 'danger'">
            {{ syncLogDetail.isSuccess ? '成功' : '失败' }}
          </el-tag>
        </div>
        <div v-if="syncLogDetail" class="sync-log-detail">
          <el-descriptions :column="2" border size="small" class="sync-log-desc">
            <el-descriptions-item label="车牌号">{{ syncLogDetail.plateNo || '-' }}</el-descriptions-item>
            <el-descriptions-item label="操作">
              <el-tag size="mini" effect="plain" :type="syncLogOperateTagType(syncLogDetail.operateType)">
                {{ syncLogDetail.operateTypeName || '-' }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="下发时间" :span="2">{{ formatDate(syncLogDetail.createTime) }}</el-descriptions-item>
            <el-descriptions-item label="CardId" :span="2">{{ syncLogDetail.cardId || '-' }}</el-descriptions-item>
          </el-descriptions>

          <el-alert
            v-if="syncLogDetail.errMsg"
            class="sync-log-detail-alert"
            :title="syncLogDetail.errMsg"
            :type="syncLogAlertType(syncLogDetail)"
            :closable="false"
            show-icon
          ></el-alert>

          <div class="sync-log-response-block">
            <div class="sync-log-response-hd">
              <span>车场系统响应</span>
              <el-button type="text" size="mini" icon="el-icon-document-copy" @click="copySyncLogResponse">复制</el-button>
            </div>
            <pre class="sync-log-pre" :class="{ 'is-empty': !syncLogDetail.responseBody }">{{ formatSyncLogJson(syncLogDetail.responseBody) }}</pre>
          </div>
        </div>
      </el-dialog>

      <!-- 导入弹窗（含 Tab：Excel导入 / 从监护人车牌导入 / 从教师车牌导入） -->
      <el-dialog title="导入免费车" :visible.sync="importDialogVisible" :close-on-click-modal="false" width="800px" custom-class="import-vehicle-dialog">
        <el-tabs v-model="importActiveTab" @tab-click="handleImportTabClick">
          <!-- Tab 1: Excel 导入 -->
          <el-tab-pane label="Excel 导入" name="excel">
            <div class="import-actions">
              <el-button size="small" icon="el-icon-download" @click="downloadTemplate">下载导入模板</el-button>
              <el-button size="small" icon="el-icon-upload" :loading="excelPreviewLoading" @click="triggerFileInput">选择文件</el-button>
              <el-button
                v-if="excelPreviewList.length"
                size="small" type="primary" icon="el-icon-check"
                :loading="excelImporting"
                @click="confirmImport"
              >确认导入（{{ excelPreviewList.filter(r => !r.error).length }} 条）</el-button>
              <el-button size="small" icon="el-icon-download" type="success" :loading="exportLoading" @click="handleExport">导出免费车列表</el-button>
              <input ref="fileInput" type="file" accept=".xlsx,.xls" style="display:none" @change="onFileChange" />
            </div>

            <!-- 预览表格 -->
            <template v-if="excelPreviewList.length">
              <el-table
                :data="excelPagedList"
                size="small"
                max-height="260"
                style="width:100%;margin-top:10px"
              >
                <el-table-column prop="rowNumber" label="行" width="50"></el-table-column>
                <el-table-column prop="plateNo" label="车牌号" min-width="110"></el-table-column>
                <el-table-column prop="ownerName" label="车主姓名" min-width="90"></el-table-column>
                <el-table-column prop="mobile" label="手机号" min-width="130"></el-table-column>
                <el-table-column label="状态" width="110">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.error" type="danger" size="mini">{{ scope.row.error }}</el-tag>
                    <el-tag v-else-if="scope.row.isDuplicate" type="warning" size="mini">已存在（跳过）</el-tag>
                    <el-tag v-else type="success" size="mini">新增</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="60">
                  <template slot-scope="scope">
                    <span style="color:#F56C6C;cursor:pointer;font-size:12px" @click="removeExcelPreviewRow(scope.$index)">移除</span>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                layout="total, sizes, prev, pager, next, jumper"
                :total="excelPreviewList.length"
                :page-sizes="pageSizes"
                :page-size="excelPreviewPageSize"
                :current-page="excelPreviewPage"
                @size-change="handleExcelPreviewSizeChange"
                @current-change="p => { excelPreviewPage = p }"
                style="text-align:right;margin-top:6px"
              ></el-pagination>
            </template>

            <!-- 导入完成结果 -->
            <div v-if="importResult" class="import-result" style="margin-top:10px">
              <el-alert
                :title="buildImportResultTitle(importResult)"
                :type="importResult.errors && importResult.errors.length ? 'warning' : 'success'"
                show-icon
                :closable="false"
              ></el-alert>
              <el-table v-if="importResult.errors && importResult.errors.length" :data="importResult.errors" size="small" style="margin-top:8px">
                <el-table-column prop="rowNumber" label="行号" width="70"></el-table-column>
                <el-table-column prop="message" label="错误信息"></el-table-column>
              </el-table>
            </div>
          </el-tab-pane>

          <!-- Tab 2: 从监护人车牌导入 -->
          <el-tab-pane label="从监护人车牌导入" name="parent">
            <div class="parent-preview-stat-cards" :class="{ 'is-summary-loading': parentPreviewLoading }">
              <div
                class="parent-preview-stat-card stat-total clickable"
                :class="{ active: parentAddedStatus === -1 }"
                @click="quickFilterParentByStatus(-1)"
              >
                <div class="stat-card-head">
                  <span class="stat-card-icon"><i class="el-icon-truck"></i></span>
                  <span class="stat-card-label">总车牌</span>
                </div>
                <div class="stat-card-value">{{ parentPreviewSummary.totalCount }}</div>
              </div>
              <div
                class="parent-preview-stat-card stat-pending clickable"
                :class="{ active: parentAddedStatus === 0 }"
                @click="quickFilterParentByStatus(0)"
              >
                <div class="stat-card-head">
                  <span class="stat-card-icon"><i class="el-icon-upload2"></i></span>
                  <span class="stat-card-label">待导入</span>
                </div>
                <div class="stat-card-value">{{ parentPreviewSummary.pendingCount }}</div>
              </div>
              <div
                class="parent-preview-stat-card stat-synced clickable"
                :class="{ active: parentAddedStatus === 1 }"
                @click="quickFilterParentByStatus(1)"
              >
                <div class="stat-card-head">
                  <span class="stat-card-icon"><i class="el-icon-circle-check"></i></span>
                  <span class="stat-card-label">已添加</span>
                </div>
                <div class="stat-card-value">{{ parentPreviewSummary.addedCount }}</div>
              </div>
            </div>
            <div class="toolbar-filter-bar toolbar-filter-bar--embed">
              <el-form :inline="true" class="toolbar-filter-form" @submit.native.prevent="handleParentSearch">
                <div class="toolbar-filter-fields">
                  <el-form-item>
                    <el-input
                      v-model="parentSearchKeyword"
                      clearable
                      placeholder="车牌/车主/手机/学生"
                      class="toolbar-field-w-xl"
                      @keyup.enter.native="handleParentSearch"
                      @clear="handleParentSearch"
                    />
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" size="small" icon="el-icon-search" @click="handleParentSearch">查询</el-button>
                  </el-form-item>
                </div>
                <div class="toolbar-filter-actions">
                  <el-button size="small" type="primary" plain icon="el-icon-refresh" @click="refreshParentPreview" :loading="parentPreviewLoading">刷新预览</el-button>
                </div>
              </el-form>
              <div class="hint-text" style="margin-top: 6px">点击汇总卡片筛选；勾选后点「确认导入」，已添加项勾选后将触发编辑下发</div>
            </div>
            <el-table
              ref="parentTable"
              :data="parentPreviewList"
              row-key="plateNo"
              v-loading="parentPreviewLoading"
              size="small"
              max-height="320"
              @selection-change="onParentSelectionChange"
              style="width:100%"
            >
              <el-table-column type="selection" width="45" :reserve-selection="true" :selectable="parentRowSelectable"></el-table-column>
              <el-table-column prop="plateNo" label="车牌号" min-width="100"></el-table-column>
              <el-table-column prop="ownerName" label="车主姓名" min-width="90"></el-table-column>
              <el-table-column prop="mobile" label="手机号" min-width="120"></el-table-column>
              <el-table-column prop="studentName" label="关联学生" min-width="90"></el-table-column>
              <el-table-column label="状态" min-width="80">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.isAlreadyAdded" type="info" size="mini">已添加</el-tag>
                  <el-tag v-else type="success" size="mini">待导入</el-tag>
                </template>
              </el-table-column>
            </el-table>
            <div style="display:flex;justify-content:flex-end;margin-top:6px">
              <el-pagination
                layout="total, sizes, prev, pager, next, jumper"
                :total="parentPreviewTotal"
                :page-sizes="pageSizes"
                :page-size="parentPageSize"
                :current-page.sync="parentPage"
                @size-change="handleParentSizeChange"
                @current-change="handleParentPageChange"
              ></el-pagination>
            </div>
            <div v-if="parentImportResult" class="import-result" style="margin-top:12px">
              <el-alert
                :title="buildParentImportResultTitle(parentImportResult)"
                :type="(parentImportResult.errors && parentImportResult.errors.length) || parentImportResult.syncFailCount > 0 ? 'warning' : 'success'"
                show-icon
                :closable="false"
              ></el-alert>
            </div>
          </el-tab-pane>

          <!-- Tab 3: 从教师车牌导入 -->
          <el-tab-pane label="从教师车牌导入" name="teacher">
            <div class="parent-preview-stat-cards" :class="{ 'is-summary-loading': teacherPreviewLoading }">
              <div
                class="parent-preview-stat-card stat-total clickable"
                :class="{ active: teacherAddedStatus === -1 }"
                @click="quickFilterTeacherByStatus(-1)"
              >
                <div class="stat-card-head">
                  <span class="stat-card-icon"><i class="el-icon-truck"></i></span>
                  <span class="stat-card-label">总车牌</span>
                </div>
                <div class="stat-card-value">{{ teacherPreviewSummary.totalCount }}</div>
              </div>
              <div
                class="parent-preview-stat-card stat-pending clickable"
                :class="{ active: teacherAddedStatus === 0 }"
                @click="quickFilterTeacherByStatus(0)"
              >
                <div class="stat-card-head">
                  <span class="stat-card-icon"><i class="el-icon-upload2"></i></span>
                  <span class="stat-card-label">待导入</span>
                </div>
                <div class="stat-card-value">{{ teacherPreviewSummary.pendingCount }}</div>
              </div>
              <div
                class="parent-preview-stat-card stat-synced clickable"
                :class="{ active: teacherAddedStatus === 1 }"
                @click="quickFilterTeacherByStatus(1)"
              >
                <div class="stat-card-head">
                  <span class="stat-card-icon"><i class="el-icon-circle-check"></i></span>
                  <span class="stat-card-label">已添加</span>
                </div>
                <div class="stat-card-value">{{ teacherPreviewSummary.addedCount }}</div>
              </div>
            </div>
            <div class="toolbar-filter-bar toolbar-filter-bar--embed">
              <el-form :inline="true" class="toolbar-filter-form" @submit.native.prevent="handleTeacherSearch">
                <div class="toolbar-filter-fields">
                  <el-form-item>
                    <el-input
                      v-model="teacherSearchKeyword"
                      clearable
                      placeholder="车牌/车主/手机/部门"
                      class="toolbar-field-w-xl"
                      @keyup.enter.native="handleTeacherSearch"
                      @clear="handleTeacherSearch"
                    />
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" size="small" icon="el-icon-search" @click="handleTeacherSearch">查询</el-button>
                  </el-form-item>
                </div>
                <div class="toolbar-filter-actions">
                  <el-button size="small" type="primary" plain icon="el-icon-refresh" @click="refreshTeacherPreview" :loading="teacherPreviewLoading">刷新预览</el-button>
                </div>
              </el-form>
              <div class="hint-text" style="margin-top: 6px">点击汇总卡片筛选；勾选后点「确认导入」，已添加项勾选后将触发编辑下发</div>
            </div>
            <el-table
              ref="teacherTable"
              :data="teacherPreviewList"
              row-key="plateNo"
              v-loading="teacherPreviewLoading"
              size="small"
              max-height="320"
              @selection-change="onTeacherSelectionChange"
              style="width:100%"
            >
              <el-table-column type="selection" width="45" :reserve-selection="true" :selectable="teacherRowSelectable"></el-table-column>
              <el-table-column prop="plateNo" label="车牌号" min-width="100"></el-table-column>
              <el-table-column prop="ownerName" label="车主姓名" min-width="90"></el-table-column>
              <el-table-column prop="mobile" label="手机号" min-width="120"></el-table-column>
              <el-table-column prop="departmentName" label="所属部门" min-width="100"></el-table-column>
              <el-table-column label="状态" min-width="80">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.isAlreadyAdded" type="info" size="mini">已添加</el-tag>
                  <el-tag v-else type="success" size="mini">待导入</el-tag>
                </template>
              </el-table-column>
            </el-table>
            <div style="display:flex;justify-content:flex-end;margin-top:6px">
              <el-pagination
                layout="total, sizes, prev, pager, next, jumper"
                :total="teacherPreviewTotal"
                :page-sizes="pageSizes"
                :page-size="teacherPageSize"
                :current-page.sync="teacherPage"
                @size-change="handleTeacherSizeChange"
                @current-change="handleTeacherPageChange"
              ></el-pagination>
            </div>
            <div v-if="teacherImportResult" class="import-result" style="margin-top:12px">
              <el-alert
                :title="buildParentImportResultTitle(teacherImportResult)"
                :type="(teacherImportResult.errors && teacherImportResult.errors.length) || teacherImportResult.syncFailCount > 0 ? 'warning' : 'success'"
                show-icon
                :closable="false"
              ></el-alert>
            </div>
          </el-tab-pane>
        </el-tabs>

        <div slot="footer">
          <el-button @click="importDialogVisible = false">关闭</el-button>
          <el-button
            v-if="importActiveTab === 'parent'"
            type="primary"
            :loading="parentImporting"
            :disabled="parentSelectedRows.length === 0"
            @click="confirmParentImport"
          >确认导入（{{ parentSelectedRows.length }}条）</el-button>
          <el-button
            v-if="importActiveTab === 'teacher'"
            type="primary"
            :loading="teacherImporting"
            :disabled="teacherSelectedRows.length === 0"
            @click="confirmTeacherImport"
          >确认导入（{{ teacherSelectedRows.length }}条）</el-button>
        </div>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import Toolbar from '@/components/Toolbar'
import PlateKeyboard from '@/components/PlateKeyboard'
import {
  getParkingConfig,
  getParkingFreeVehiclePage,
  getParkingFreeVehicleSummary,
  addParkingFreeVehicle,
  editParkingFreeVehicle,
  deleteParkingFreeVehicle,
  deleteParkingFreeVehicleByIds,
  retrySyncParkingVehicle,
  syncByIds,
  downloadParkingImportTemplate,
  exportParkingFreeVehicle,
  previewImportParkingFreeVehicle,
  importFromPreview,
  previewParentVehicles,
  importFromParentVehicles,
  previewTeacherVehicles,
  importFromTeacherVehicles,
  getParkingSyncLogPage,
  getParkingSyncLogDetail,
  exportParkingSyncLog,
  getParkingBatchSyncJobPage,
  getParkingBatchSyncJobItemPage,
  getParkingBatchSyncJobRunning
} from '@/api/parking'
import { loadButtonFuncs, buildToolbarButtons } from './parkingUtils'

const TOOLBAR_BUTTONS = [
  { name: '查询', Func: 'handleSearchBtn', icon: 'el-icon-search', always: true },
  { name: '新增', Func: 'openAdd', icon: 'el-icon-plus' },
  { name: '导入/导出', Func: 'openImport', icon: 'el-icon-upload2', btnType: 'default' },
  { name: '批量同步', Func: 'handleRetryBatch', icon: 'el-icon-refresh', btnType: 'warning' },
  { name: '批量删除', Func: 'handleDeleteBatch', icon: 'el-icon-delete', btnType: 'danger' }
]

export default {
  name: 'ParkingFreeVehicle',
  components: { Toolbar, PlateKeyboard },
  data() {
    return {
      schoolId: null,
      listLoading: false,
      summaryLoading: false,
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 10,
      pageSizes: [10, 20, 50, 100, 200],
      selectedRows: [],
      // 搜索
      searchPlateNo: '',
      searchOwnerName: '',
      searchSyncStatus: -1,
      summary: {
        totalCount: 0,
        pendingCount: 0,
        syncedCount: 0,
        failedCount: 0,
        pendingUpdateCount: 0
      },
      // 编辑
      editFormVisible: false,
      editSaving: false,
      showPlateKeyboard: false,
      editForm: { id: null, plateNo: '', ownerName: '', mobile: '', endTypeLong: true, bTime: null, eTime: null },
      editRules: {
        plateNo: [{
          validator: (rule, value, callback) => {
            const v = (value || '').trim()
            if (!v) {
              callback(new Error('请输入车牌号'))
            } else if (v.length < 7) {
              callback(new Error('请输入完整车牌号'))
            } else {
              callback()
            }
          },
          trigger: ['blur', 'change']
        }]
      },
      // 导入/导出
      importDialogVisible: false,
      importActiveTab: 'excel',
      importResult: null,
      excelPreviewList: [],
      excelPreviewFile: null,
      excelPreviewLoading: false,
      excelImporting: false,
      excelPreviewPage: 1,
      excelPreviewPageSize: 10,
      exportLoading: false,
      // 监护人导入
      parentPreviewList: [],
      parentPreviewLoading: false,
      parentPreviewTotal: 0,
      parentPreviewRequestId: 0,
      parentPage: 1,
      parentPageSize: 10,
      parentAddedStatus: -1,
      parentSearchKeyword: '',
      parentPreviewSummary: {
        totalCount: 0,
        pendingCount: 0,
        addedCount: 0
      },
      parentSelectedRows: [],
      parentImporting: false,
      parentImportResult: null,
      // 教师导入
      teacherPreviewList: [],
      teacherPreviewLoading: false,
      teacherPreviewTotal: 0,
      teacherPreviewRequestId: 0,
      teacherPage: 1,
      teacherPageSize: 10,
      teacherAddedStatus: -1,
      teacherSearchKeyword: '',
      teacherPreviewSummary: {
        totalCount: 0,
        pendingCount: 0,
        addedCount: 0
      },
      teacherSelectedRows: [],
      teacherImporting: false,
      teacherImportResult: null,
      // 同步日志
      syncLogVisible: false,
      syncLogLoading: false,
      syncLogExportLoading: false,
      syncLogList: [],
      syncLogTotal: 0,
      syncLogPage: 1,
      syncLogPageSize: 10,
      syncLogVehicleId: null,
      syncLogVehiclePlate: '',
      syncLogSearchPlateNo: '',
      syncLogSearchOperateType: -1,
      syncLogSearchIsSuccess: -1,
      syncLogDetailVisible: false,
      syncLogDetail: null,
      // 批量下发任务
      batchSyncJobVisible: false,
      batchSyncJobLoading: false,
      batchSyncJobList: [],
      batchSyncJobTotal: 0,
      batchSyncJobPage: 1,
      batchSyncJobPageSize: 10,
      activeBatchSyncJob: null,
      batchSyncPollTimer: null,
      batchSyncJobDetailVisible: false,
      batchSyncJobDetailTitle: '下发明细',
      currentBatchSyncJobId: null,
      batchSyncJobItemList: [],
      batchSyncJobItemLoading: false,
      batchSyncJobItemTotal: 0,
      batchSyncJobItemPage: 1,
      batchSyncJobItemPageSize: 10,
      // toolbar
      buttonFuncs: [],
      buttonList: [],
      searchList: [
        { key: 'searchPlateNo', label: '车牌号', width: '132px' },
        { key: 'searchOwnerName', label: '车主姓名', width: '132px' },
        {
          key: 'searchSyncStatus', label: '同步状态', type: 'select', clearable: true, initValue: -1, width: '118px',
          options: [
            { value: -1, label: '全部' },
            { value: 0, label: '待同步' },
            { value: 1, label: '已下发' },
            { value: 2, label: '下发失败' },
            { value: 3, label: '待更新' }
          ]
        }
      ]
    }
  },
  computed: {
    excelPagedList() {
      const start = (this.excelPreviewPage - 1) * this.excelPreviewPageSize
      return this.excelPreviewList.slice(start, start + this.excelPreviewPageSize)
    }
  },
  watch: {
    // 监听全局活跃学校 ID 的变化，实现静默重载数据
    '$store.state.activeSchoolId': {
      handler(newVal) {
        if (newVal) {
          this.schoolId = newVal
          this.page = 1
          this.loadData()
        }
      },
      immediate: true
    }
  },
  created() {
    this.buttonFuncs = loadButtonFuncs(this.$route.path)
    this.buttonList = buildToolbarButtons(TOOLBAR_BUTTONS, this.buttonFuncs)
  },
  beforeDestroy() {
    this.stopBatchSyncPolling()
  },
  methods: {
    /** 当前角色是否分配了该按钮权限 */
    can(func) {
      return this.buttonFuncs.includes(func)
    },
    callFunction(item) {
      if (item.Func && typeof this[item.Func] === 'function') {
        this[item.Func](item)
        return
      }
      if (item.search) this.handleSearch(item.search)
    },
    handleSearchBtn(item) {
      this.handleSearch(item.search || {})
    },
    handleSearch(searchData) {
      const prevPlate = this.searchPlateNo
      const prevOwner = this.searchOwnerName
      if (searchData) {
        this.searchPlateNo = searchData.searchPlateNo || ''
        this.searchOwnerName = searchData.searchOwnerName || ''
        const rawStatus = searchData.searchSyncStatus
        this.searchSyncStatus = (rawStatus === '' || rawStatus == null) ? -1 : rawStatus
      }
      this.page = 1
      const summaryScopeChanged = prevPlate !== this.searchPlateNo || prevOwner !== this.searchOwnerName
      if (summaryScopeChanged) {
        this.loadSummary()
      }
      this.loadList()
    },
    buildFilterParams() {
      const params = { schoolId: this.schoolId }
      if (this.searchPlateNo) params.plateNo = this.searchPlateNo
      if (this.searchOwnerName) params.ownerName = this.searchOwnerName
      const syncStatus = this.searchSyncStatus
      if (syncStatus !== '' && syncStatus != null && syncStatus >= 0) {
        params.syncStatus = syncStatus
      }
      return params
    },
    /** 汇总参数：不含同步状态，卡片始终展示全量分布 */
    buildSummaryParams() {
      const params = { schoolId: this.schoolId }
      if (this.searchPlateNo) params.plateNo = this.searchPlateNo
      if (this.searchOwnerName) params.ownerName = this.searchOwnerName
      return params
    },
    async loadData() {
      if (!this.schoolId) return
      await Promise.all([this.loadSummary(), this.loadList()])
    },
    async loadSummary() {
      if (!this.schoolId) return
      this.summaryLoading = true
      try {
        const res = await getParkingFreeVehicleSummary(this.buildSummaryParams())
        if (res.data && res.data.success) {
          const r = res.data.response || {}
          this.summary = {
            totalCount: r.TotalCount != null ? r.TotalCount : (r.totalCount || 0),
            pendingCount: r.PendingCount != null ? r.PendingCount : (r.pendingCount || 0),
            syncedCount: r.SyncedCount != null ? r.SyncedCount : (r.syncedCount || 0),
            failedCount: r.FailedCount != null ? r.FailedCount : (r.failedCount || 0),
            pendingUpdateCount: r.PendingUpdateCount != null ? r.PendingUpdateCount : (r.pendingUpdateCount || 0)
          }
        }
      } catch (e) {
        // 汇总失败不阻断列表
      } finally {
        this.summaryLoading = false
      }
    },
    quickFilterByStatus(status) {
      if (this.searchSyncStatus === status) return
      this.searchSyncStatus = status
      this.page = 1
      this.syncToolbarField('searchSyncStatus', status)
      this.loadList()
    },
    syncToolbarField(key, value) {
      const toolbar = this.$refs.toolbar
      if (!toolbar || !toolbar.searchObj) return
      toolbar.searchObj[key] = value
    },
    async loadList() {
      if (!this.schoolId) return
      this.listLoading = true
      try {
        const res = await getParkingFreeVehiclePage({
          ...this.buildFilterParams(),
          page: this.page,
          pageSize: this.pageSize
        })
        if (res.data && res.data.success) {
          const resp = res.data.response || {}
          this.tableData = (resp.data || []).map(r => ({
            id: r.Id || r.id,
            plateNo: r.PlateNo || r.plateNo || '',
            ownerName: r.OwnerName || r.ownerName || '',
            mobile: r.Mobile || r.mobile || '',
            endType: r.EndType != null ? r.EndType : r.endType,
            bTime: r.BTime || r.bTime || null,
            eTime: r.ETime || r.eTime || null,
            sourceType: r.SourceType != null ? r.SourceType : r.sourceType,
            sourceTypeName: r.SourceTypeName || r.sourceTypeName || '',
            syncStatus: r.SyncStatus != null ? r.SyncStatus : r.syncStatus,
            syncStatusName: r.SyncStatusName || r.syncStatusName || '',
            syncTime: r.SyncTime || r.syncTime || null,
            syncError: r.SyncError || r.syncError || '',
            createTime: r.CreateTime || r.createTime || ''
          }))
          this.total = resp.dataCount || resp.DataCount || 0
        }
      } catch (e) {
        this.$message.error('加载列表失败')
      } finally {
        this.listLoading = false
      }
    },
    handleCurrentChange(val) {
      this.page = val
      this.loadList()
    },
    handleSizeChange(val) {
      this.pageSize = Math.min(val, 200)
      this.page = 1
      this.loadList()
    },
    onSelectionChange(rows) {
      this.selectedRows = rows
    },
    selectCurrentRow(row) {
      this.$refs.table && this.$refs.table.toggleRowSelection(row)
    },
    async openAdd() {
      if (!this.schoolId) { this.$message.warning('请先选择学校'); return }
      let endTypeLong = true
      let bTime = null
      let eTime = null
      try {
        const res = await getParkingConfig(this.schoolId)
        if (res.data && res.data.success && res.data.response) {
          const c = res.data.response
          const endType = c.EndType !== undefined ? c.EndType : c.endType
          endTypeLong = endType !== 0
          bTime = c.BTime || c.bTime || null
          eTime = c.ETime || c.eTime || null
        }
      } catch (e) { /* 使用默认长期 */ }
      this.editForm = { id: null, plateNo: '', ownerName: '', mobile: '', endTypeLong, bTime, eTime }
      this.showPlateKeyboard = true
      this.$nextTick(() => this.$refs.editForm && this.$refs.editForm.clearValidate())
      this.editFormVisible = true
    },
    openEdit(row) {
      this.editForm = {
        id: row.id,
        plateNo: row.plateNo,
        ownerName: row.ownerName || '',
        mobile: row.mobile || '',
        endTypeLong: row.endType !== 0,
        bTime: row.bTime || null,
        eTime: row.eTime || null
      }
      this.showPlateKeyboard = false
      this.$nextTick(() => this.$refs.editForm && this.$refs.editForm.clearValidate())
      this.editFormVisible = true
    },
    buildVehiclePayload() {
      return {
        id: this.editForm.id,
        plateNo: (this.editForm.plateNo || '').trim(),
        ownerName: this.editForm.ownerName,
        mobile: this.editForm.mobile,
        endType: this.editForm.endTypeLong ? 1 : 0,
        bTime: this.editForm.endTypeLong ? null : this.editForm.bTime,
        eTime: this.editForm.endTypeLong ? null : this.editForm.eTime
      }
    },
    /** 车牌号变更后同步表单校验（虚拟键盘录入不会触发 el-input 的 change 事件） */
    syncPlateNoValidation() {
      this.$nextTick(() => {
        const form = this.$refs.editForm
        if (!form) return
        form.validateField('plateNo', () => {})
      })
    },
    submitEdit() {
      const plateNo = (this.editForm.plateNo || '').trim()
      this.$set(this.editForm, 'plateNo', plateNo)
      this.$refs.editForm.validate(async valid => {
        if (!valid) return
        if (!this.editForm.endTypeLong && (!this.editForm.bTime || !this.editForm.eTime)) {
          this.$message.warning('非长期免费时请填写开始和结束时间')
          return
        }
        this.editSaving = true
        try {
          const payload = this.buildVehiclePayload()
          let res
          if (this.editForm.id) {
            res = await editParkingFreeVehicle(payload)
          } else {
            res = await addParkingFreeVehicle({ schoolId: this.schoolId, ...payload })
          }
          if (res.data && res.data.success) {
            this.$message.success(this.editForm.id ? '编辑成功' : '新增成功')
            this.editFormVisible = false
            this.loadData()
          } else {
            this.$message.error(res.data && res.data.msg || '操作失败')
          }
        } catch (e) {
          this.$message.error('操作失败')
        } finally {
          this.editSaving = false
        }
      })
    },
    handleDelete(row) {
      this.$confirm(`确认删除车牌「${row.plateNo}」？将同步从车场白名单中移除。`, '提示', {
        type: 'warning'
      }).then(async () => {
        try {
          const res = await deleteParkingFreeVehicle(row.id)
          if (res.data && res.data.success) {
            this.$message.success('删除成功')
            this.loadData()
          } else {
            this.$message.error(res.data && res.data.msg || '删除失败')
          }
        } catch (e) {
          this.$message.error('删除失败')
        }
      }).catch(() => {})
    },
    async handleRetry(row) {
      try {
        const res = await retrySyncParkingVehicle(row.id)
        if (res.data && res.data.success) {
          this.$message.success('重试下发成功')
          this.loadData()
        } else {
          this.$message.error(res.data && res.data.msg || '重试失败')
        }
      } catch (e) {
        this.$message.error('重试失败')
      }
    },
    async handleRetryBatch() {
      if (!this.schoolId) { this.$message.warning('请先选择学校'); return }
      const syncable = this.selectedRows.filter(r => r.syncStatus === 0 || r.syncStatus === 2 || r.syncStatus === 3)
      if (!syncable.length) {
        this.$message.warning('请先勾选需要同步的记录（待同步/下发失败/待更新）')
        return
      }
      try {
        const res = await syncByIds(this.schoolId, syncable.map(r => r.id))
        if (res.data && res.data.success) {
          this.$message.success(res.data.msg || '批量同步完成')
          this.loadData()
        } else {
          this.$message.error(res.data && res.data.msg || '操作失败')
        }
      } catch (e) {
        this.$message.error('操作失败')
      }
    },
    handleDeleteBatch() {
      if (!this.schoolId) { this.$message.warning('请先选择学校'); return }
      if (!this.selectedRows.length) {
        this.$message.warning('请先勾选要删除的记录')
        return
      }
      const count = this.selectedRows.length
      this.$confirm(`确认删除已勾选的 ${count} 条记录？将同步从车场白名单中移除。`, '提示', {
        type: 'warning'
      }).then(async () => {
        try {
          const res = await deleteParkingFreeVehicleByIds(this.schoolId, this.selectedRows.map(r => r.id))
          if (res.data && res.data.success) {
            this.$message.success(res.data.msg || '批量删除成功')
            this.loadData()
          } else {
            this.$message.error(res.data && res.data.msg || '批量删除失败')
          }
        } catch (e) {
          this.$message.error('批量删除失败')
        }
      }).catch(() => {})
    },
    openSyncLog(row) {
      if (!this.schoolId) { this.$message.warning('请先选择学校'); return }
      this.syncLogVehicleId = row.id
      this.syncLogVehiclePlate = row.plateNo || ''
      this.resetSyncLogSearch(false)
      this.syncLogSearchPlateNo = this.syncLogVehiclePlate
      this.syncLogPage = 1
      this.syncLogVisible = true
    },
    openSchoolSyncLog() {
      if (!this.schoolId) { this.$message.warning('请先选择学校'); return }
      this.syncLogVehicleId = null
      this.syncLogVehiclePlate = ''
      this.resetSyncLogSearch(false)
      this.syncLogPage = 1
      this.syncLogVisible = true
    },
    /** 组装同步日志查询参数 */
    buildSyncLogQueryParams() {
      const params = {
        schoolId: this.schoolId,
        page: this.syncLogPage,
        pageSize: this.syncLogPageSize
      }
      if (this.syncLogVehicleId) params.vehicleId = this.syncLogVehicleId
      const plateNo = (this.syncLogSearchPlateNo || '').trim()
      if (plateNo) params.plateNo = plateNo
      if (this.syncLogSearchOperateType > 0) params.operateType = this.syncLogSearchOperateType
      if (this.syncLogSearchIsSuccess !== -1) params.isSuccess = this.syncLogSearchIsSuccess === 1
      return params
    },
    handleSyncLogSearch() {
      this.syncLogPage = 1
      this.loadSyncLogList()
    },
    resetSyncLogSearch(reload = true) {
      this.syncLogSearchPlateNo = ''
      this.syncLogSearchOperateType = -1
      this.syncLogSearchIsSuccess = -1
      this.syncLogPage = 1
      if (reload && this.syncLogVisible) this.loadSyncLogList()
    },
    async handleExportSyncLog() {
      if (!this.schoolId || this.syncLogExportLoading) return
      this.syncLogExportLoading = true
      try {
        const params = { schoolId: this.schoolId }
        if (this.syncLogVehicleId) params.vehicleId = this.syncLogVehicleId
        const plateNo = (this.syncLogSearchPlateNo || '').trim()
        if (plateNo) params.plateNo = plateNo
        if (this.syncLogSearchOperateType > 0) params.operateType = this.syncLogSearchOperateType
        if (this.syncLogSearchIsSuccess !== -1) params.isSuccess = this.syncLogSearchIsSuccess === 1
        const res = await exportParkingSyncLog(params)
        const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        const plateSuffix = this.syncLogVehiclePlate ? `_${this.syncLogVehiclePlate}` : ''
        const d = new Date()
        const pad = n => String(n).padStart(2, '0')
        link.setAttribute('download', `同步日志${plateSuffix}_${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}.xlsx`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
        this.$message.success('导出成功，文件已开始下载')
      } catch (e) {
        this.$message.error('导出同步日志失败')
      } finally {
        this.syncLogExportLoading = false
      }
    },
    mapSyncLogRow(r) {
      return {
        id: r.Id || r.id,
        vehicleId: r.VehicleId != null ? r.VehicleId : r.vehicleId,
        plateNo: r.PlateNo || r.plateNo || '',
        operateType: r.OperateType != null ? r.OperateType : r.operateType,
        operateTypeName: r.OperateTypeName || r.operateTypeName || '',
        cardId: r.CardId || r.cardId || '',
        isSuccess: r.IsSuccess !== undefined ? r.IsSuccess : r.isSuccess,
        errMsg: r.ErrMsg || r.errMsg || '',
        responseBody: r.ResponseBody || r.responseBody || '',
        createTime: r.CreateTime || r.createTime
      }
    },
    async loadSyncLogList() {
      if (!this.schoolId) return
      this.syncLogLoading = true
      try {
        const res = await getParkingSyncLogPage(this.buildSyncLogQueryParams())
        if (res.data && res.data.success) {
          const resp = res.data.response || {}
          this.syncLogList = (resp.data || []).map(r => this.mapSyncLogRow(r))
          this.syncLogTotal = resp.dataCount || resp.DataCount || 0
        }
      } catch (e) {
        this.$message.error('加载同步日志失败')
      } finally {
        this.syncLogLoading = false
      }
    },
    async openSyncLogDetail(row) {
      if (!row || !row.id || !this.schoolId) return
      this.syncLogDetailVisible = true
      this.syncLogDetail = { ...row, responseBody: '' }
      try {
        const res = await getParkingSyncLogDetail(row.id, this.schoolId)
        if (res.data && res.data.success) {
          this.syncLogDetail = this.mapSyncLogRow(res.data.response || {})
        } else {
          this.$message.error(res.data && res.data.msg || '加载详情失败')
        }
      } catch (e) {
        this.$message.error('加载详情失败')
      }
    },
    syncLogAlertType(row) {
      if (!row.isSuccess) return 'error'
      if (row.errMsg && row.errMsg.indexOf('未同步') >= 0) return 'warning'
      return 'success'
    },
    /** 同步日志操作类型标签颜色 */
    syncLogOperateTagType(operateType) {
      const map = { 1: 'success', 2: 'warning', 3: 'danger' }
      return map[operateType] || 'info'
    },
    formatSyncLogJson(raw) {
      if (!raw) return '（无响应内容）'
      try {
        return JSON.stringify(JSON.parse(raw), null, 2)
      } catch (e) {
        return raw
      }
    },
    copySyncLogResponse() {
      const text = this.formatSyncLogJson(this.syncLogDetail && this.syncLogDetail.responseBody)
      if (!text || text === '（无响应内容）') {
        this.$message.warning('暂无内容可复制')
        return
      }
      navigator.clipboard.writeText(text).then(() => {
        this.$message.success('已复制到剪贴板')
      }).catch(() => {
        this.$message.warning('复制失败')
      })
    },
    handleSyncLogPageChange(page) {
      this.syncLogPage = page
      this.loadSyncLogList()
    },
    handleSyncLogSizeChange(size) {
      this.syncLogPageSize = Math.min(size, 200)
      this.syncLogPage = 1
      this.loadSyncLogList()
    },
    openImport() {
      if (!this.schoolId) { this.$message.warning('请先选择学校'); return }
      this.importResult = null
      this.excelPreviewList = []
      this.excelPreviewFile = null
      this.parentImportResult = null
      this.parentPreviewList = []
      this.parentPage = 1
      this.parentAddedStatus = -1
      this.parentSearchKeyword = ''
      this.parentPreviewSummary = { totalCount: 0, pendingCount: 0, addedCount: 0 }
      this.teacherImportResult = null
      this.teacherPreviewList = []
      this.teacherPage = 1
      this.teacherAddedStatus = -1
      this.teacherSearchKeyword = ''
      this.teacherPreviewSummary = { totalCount: 0, pendingCount: 0, addedCount: 0 }
      this.importActiveTab = 'excel'
      this.importDialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.parentTable) this.clearParentSelection()
        if (this.$refs.teacherTable) this.clearTeacherSelection()
      })
    },
    handleImportTabClick(tab) {
      if (tab.name === 'parent') {
        this.loadParentPreview()
      } else if (tab.name === 'teacher') {
        this.loadTeacherPreview()
      }
    },
    downloadTemplate() {
      window.open(downloadParkingImportTemplate(), '_blank')
    },
    async handleExport() {
      if (!this.schoolId) {
        this.$message.warning('请先选择学校')
        return
      }
      try {
        const res = await exportParkingFreeVehicle(this.schoolId)
        const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        const pad = n => String(n).padStart(2, '0')
        const d = new Date()
        link.setAttribute('download', `免费车列表_${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}.xlsx`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
        this.$message.success('导出成功，文件已开始下载')
      } catch (e) {
        this.$message.error('导出失败')
      }
    },
    triggerFileInput() {
      this.$refs.fileInput && this.$refs.fileInput.click()
    },
    async onFileChange(e) {
      const file = e.target.files && e.target.files[0]
      if (!file) return
      this.importResult = null
      this.excelPreviewList = []
      this.excelPreviewPage = 1
      this.excelPreviewFile = file
      this.excelPreviewLoading = true
      try {
        const res = await previewImportParkingFreeVehicle(this.schoolId, file)
        if (res.data && res.data.success) {
          const rows = res.data.response || []
          this.excelPreviewList = rows.map(r => ({
            rowNumber: r.RowNumber !== undefined ? r.RowNumber : r.rowNumber,
            plateNo: r.PlateNo || r.plateNo || '',
            ownerName: r.OwnerName || r.ownerName || '',
            mobile: r.Mobile || r.mobile || '',
            isDuplicate: r.IsDuplicate !== undefined ? r.IsDuplicate : r.isDuplicate,
            error: r.Error || r.error || ''
          }))
        } else {
          this.$message.error(res.data && res.data.msg || '解析失败')
        }
      } catch (e) {
        this.$message.error('解析失败')
      } finally {
        this.excelPreviewLoading = false
        this.$refs.fileInput.value = ''
      }
    },
    removeExcelPreviewRow(pageIndex) {
      const globalIndex = (this.excelPreviewPage - 1) * this.excelPreviewPageSize + pageIndex
      this.excelPreviewList.splice(globalIndex, 1)
      // 移除后若当前页已无数据则退回上一页
      const maxPage = Math.ceil(this.excelPreviewList.length / this.excelPreviewPageSize) || 1
      if (this.excelPreviewPage > maxPage) this.excelPreviewPage = maxPage
    },
    async confirmImport() {
      const rows = this.excelPreviewList
        .filter(r => !r.error)
        .map(r => ({ plateNo: r.plateNo, ownerName: r.ownerName, mobile: r.mobile }))
      if (!rows.length) {
        this.$message.warning('没有可导入的有效数据')
        return
      }
      if (this.excelImporting) return
      this.excelImporting = true
      this.importResult = null
      const loading = this.$loading({
        lock: true,
        text: '正在导入，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.35)'
      })
      try {
        const res = await importFromPreview(this.schoolId, rows, { skipGlobalHttpErrorToast: true })
        if (!res.data || !res.data.success) {
          throw new Error((res.data && res.data.msg) || '导入失败')
        }
        const r = res.data.response || {}
        this.importResult = this.mapImportResult(r)
        this.excelPreviewList = []
        this.excelPreviewFile = null
        this.loadData()
        this.loadActiveBatchSyncJob()
        this.$message.success(res.data.msg || this.buildImportResultTitle(this.importResult))
      } catch (e) {
        const msg = (e.response && e.response.data && e.response.data.msg) || e.message || '导入失败'
        this.$message.error(msg)
      } finally {
        loading.close()
        this.excelImporting = false
      }
    },
    mapImportResult(r) {
      return {
        successCount: r.SuccessCount != null ? r.SuccessCount : (r.successCount || 0),
        skipCount: r.SkipCount != null ? r.SkipCount : (r.skipCount || 0),
        syncFailCount: r.SyncFailCount != null ? r.SyncFailCount : (r.syncFailCount || 0),
        pendingSyncCount: r.PendingSyncCount != null ? r.PendingSyncCount : (r.pendingSyncCount || 0),
        batchSyncJobId: r.BatchSyncJobId != null ? r.BatchSyncJobId : (r.batchSyncJobId || null),
        errors: (r.Errors || r.errors || []).map(e => ({
          rowNumber: e.RowNumber != null ? e.RowNumber : e.rowNumber,
          message: e.Message || e.message || ''
        }))
      }
    },
    buildImportResultTitle(result) {
      if (!result) return ''
      if (result.pendingSyncCount > 0) {
        return `已导入 ${result.successCount} 条，跳过 ${result.skipCount} 条；${result.pendingSyncCount} 条已加入后台下发`
      }
      return `导入完成：成功 ${result.successCount} 条，跳过 ${result.skipCount} 条`
    },
    buildParentImportResultTitle(result) {
      if (!result) return ''
      if (result.pendingSyncCount > 0) {
        return `新增 ${result.addedCount} 条，更新 ${result.updatedCount} 条；${result.pendingSyncCount} 条已加入后台下发`
      }
      return `完成：新增 ${result.addedCount} 条，更新 ${result.updatedCount} 条`
    },
    mapBatchSyncJob(r) {
      return {
        id: r.Id || r.id,
        sourceName: r.SourceName || r.sourceName || '',
        operatorName: r.OperatorName || r.operatorName || '',
        status: r.Status != null ? r.Status : r.status,
        statusName: r.StatusName || r.statusName || '',
        totalCount: r.TotalCount != null ? r.TotalCount : (r.totalCount || 0),
        successCount: r.SuccessCount != null ? r.SuccessCount : (r.successCount || 0),
        failCount: r.FailCount != null ? r.FailCount : (r.failCount || 0),
        startTime: r.StartTime || r.startTime,
        endTime: r.EndTime || r.endTime
      }
    },
    openBatchSyncJobs() {
      if (!this.schoolId) { this.$message.warning('请先选择学校'); return }
      this.batchSyncJobPage = 1
      this.batchSyncJobVisible = true
    },
    onBatchSyncJobDialogOpen() {
      this.loadActiveBatchSyncJob()
      this.loadBatchSyncJobList()
      this.startBatchSyncPolling()
    },
    async loadActiveBatchSyncJob() {
      if (!this.schoolId) return
      try {
        const res = await getParkingBatchSyncJobRunning(this.schoolId)
        if (res.data && res.data.success) {
          const r = res.data.response
          this.activeBatchSyncJob = r ? this.mapBatchSyncJob(r) : null
        }
      } catch (e) {
        this.activeBatchSyncJob = null
      }
    },
    async loadBatchSyncJobList() {
      if (!this.schoolId) return
      this.batchSyncJobLoading = true
      try {
        const res = await getParkingBatchSyncJobPage({
          schoolId: this.schoolId,
          page: this.batchSyncJobPage,
          pageSize: this.batchSyncJobPageSize
        })
        if (res.data && res.data.success) {
          const resp = res.data.response || {}
          this.batchSyncJobList = (resp.data || []).map(r => this.mapBatchSyncJob(r))
          this.batchSyncJobTotal = resp.dataCount || 0
        }
      } finally {
        this.batchSyncJobLoading = false
      }
    },
    /** 下发记录切换每页条数后回到第一页 */
    handleBatchSyncJobSizeChange(size) {
      this.batchSyncJobPageSize = size
      this.batchSyncJobPage = 1
      this.loadBatchSyncJobList()
    },
    openBatchSyncJobDetail(row) {
      this.currentBatchSyncJobId = row.id
      this.batchSyncJobDetailTitle = `下发明细 - ${row.sourceName || ''}`
      this.batchSyncJobItemPage = 1
      this.batchSyncJobDetailVisible = true
    },
    async loadBatchSyncJobItems() {
      if (!this.currentBatchSyncJobId) return
      this.batchSyncJobItemLoading = true
      try {
        const res = await getParkingBatchSyncJobItemPage({
          jobId: this.currentBatchSyncJobId,
          page: this.batchSyncJobItemPage,
          pageSize: this.batchSyncJobItemPageSize
        })
        if (res.data && res.data.success) {
          const resp = res.data.response || {}
          this.batchSyncJobItemList = (resp.data || []).map(r => ({
            plateNo: r.PlateNo || r.plateNo || '',
            operateTypeName: r.OperateTypeName || r.operateTypeName || '',
            processStatus: r.ProcessStatus != null ? r.ProcessStatus : r.processStatus,
            processStatusName: r.ProcessStatusName || r.processStatusName || '',
            resultMessage: r.ResultMessage || r.resultMessage || '',
            finishedTime: r.FinishedTime || r.finishedTime
          }))
          this.batchSyncJobItemTotal = resp.dataCount || 0
        }
      } finally {
        this.batchSyncJobItemLoading = false
      }
    },
    startBatchSyncPolling() {
      this.stopBatchSyncPolling()
      this.batchSyncPollTimer = setInterval(async () => {
        await this.loadActiveBatchSyncJob()
        if (this.batchSyncJobVisible) await this.loadBatchSyncJobList()
        if (!this.activeBatchSyncJob) this.stopBatchSyncPolling()
      }, 3000)
    },
    stopBatchSyncPolling() {
      if (this.batchSyncPollTimer) {
        clearInterval(this.batchSyncPollTimer)
        this.batchSyncPollTimer = null
      }
    },
    /** 已添加行不可勾选 */
    parentRowSelectable(row) {
      return !row.isAlreadyAdded
    },
    /** 从表格同步跨页勾选（reserve-selection 后需翻页时回读） */
    syncParentSelectedFromTable() {
      this.$nextTick(() => {
        const table = this.$refs.parentTable
        if (!table) return
        this.parentSelectedRows = table.selection ? [...table.selection] : []
      })
    },
    /** 清空监护人预览勾选 */
    clearParentSelection() {
      this.parentSelectedRows = []
      const table = this.$refs.parentTable
      if (table) table.clearSelection()
    },
    /** 刷新预览并清空勾选 */
    refreshParentPreview() {
      this.parentImportResult = null
      this.clearParentSelection()
      this.loadParentPreview()
    },
    async loadParentPreview() {
      if (!this.schoolId) return
      const requestId = ++this.parentPreviewRequestId
      const requestPage = this.parentPage
      this.parentPreviewLoading = true
      try {
        const res = await previewParentVehicles({
          schoolId: this.schoolId,
          page: requestPage,
          pageSize: this.parentPageSize,
          addedStatus: this.parentAddedStatus,
          keyword: (this.parentSearchKeyword || '').trim() || undefined
        })
        if (requestId !== this.parentPreviewRequestId || requestPage !== this.parentPage) return
        if (res.data && res.data.success) {
          const resp = res.data.response || {}
          const rows = resp.data || resp.Data || []
          this.parentPreviewList = rows.map(r => ({
            plateNo: r.PlateNo || r.plateNo || '',
            ownerName: r.OwnerName || r.ownerName || '',
            mobile: r.Mobile || r.mobile || '',
            studentName: r.StudentName || r.studentName || '',
            isAlreadyAdded: r.IsAlreadyAdded != null ? r.IsAlreadyAdded : (r.isAlreadyAdded || false),
            existingVehicleId: r.ExistingVehicleId != null ? r.ExistingVehicleId : (r.existingVehicleId || null),
            sourceVehicleId: r.SourceVehicleId != null ? r.SourceVehicleId : (r.sourceVehicleId || null)
          }))
          this.parentPreviewTotal = resp.dataCount != null ? resp.dataCount : (resp.DataCount || 0)
          const summary = resp.summary || resp.Summary
          if (summary) {
            this.parentPreviewSummary = {
              totalCount: summary.TotalCount != null ? summary.TotalCount : (summary.totalCount || 0),
              pendingCount: summary.PendingCount != null ? summary.PendingCount : (summary.pendingCount || 0),
              addedCount: summary.AddedCount != null ? summary.AddedCount : (summary.addedCount || 0)
            }
          }
          this.syncParentSelectedFromTable()
        }
      } catch (e) {
        if (requestId === this.parentPreviewRequestId) {
          this.$message.error('加载监护人车牌失败')
        }
      } finally {
        if (requestId === this.parentPreviewRequestId) {
          this.parentPreviewLoading = false
        }
      }
    },
    handleExcelPreviewSizeChange(size) {
      this.excelPreviewPageSize = Math.min(size, 200)
      this.excelPreviewPage = 1
    },
    quickFilterParentByStatus(status) {
      if (this.parentAddedStatus === status) return
      this.parentAddedStatus = status
      this.parentPage = 1
      this.clearParentSelection()
      this.loadParentPreview()
    },
    handleParentSearch() {
      this.parentPage = 1
      this.clearParentSelection()
      this.loadParentPreview()
    },
    handleParentPageChange(val) {
      this.parentPage = val
      this.loadParentPreview()
    },
    handleParentSizeChange(size) {
      this.parentPageSize = Math.min(size, 200)
      this.parentPage = 1
      this.loadParentPreview()
    },
    onParentSelectionChange(rows) {
      // reserve-selection 已跨页保留；此处直接同步表格全部已选行
      this.parentSelectedRows = rows
    },
    async confirmParentImport() {
      if (this.parentSelectedRows.length === 0) return
      this.parentImporting = true
      this.parentImportResult = null
      try {
        const items = this.parentSelectedRows.map(r => ({
          plateNo: r.plateNo,
          ownerName: r.ownerName,
          mobile: r.mobile,
          isAlreadyAdded: r.isAlreadyAdded,
          existingVehicleId: r.existingVehicleId || null,
          sourceVehicleId: r.sourceVehicleId || null
        }))
        const res = await importFromParentVehicles(this.schoolId, items)
        if (res.data && res.data.success) {
          const pr = res.data.response || {}
          this.parentImportResult = {
            addedCount: pr.AddedCount !== undefined ? pr.AddedCount : pr.addedCount,
            updatedCount: pr.UpdatedCount !== undefined ? pr.UpdatedCount : pr.updatedCount,
            syncFailCount: pr.SyncFailCount !== undefined ? pr.SyncFailCount : pr.syncFailCount,
            pendingSyncCount: pr.PendingSyncCount != null ? pr.PendingSyncCount : (pr.pendingSyncCount || 0),
            batchSyncJobId: pr.BatchSyncJobId != null ? pr.BatchSyncJobId : (pr.batchSyncJobId || null)
          }
          this.loadData()
          this.loadActiveBatchSyncJob()
          await this.loadParentPreview()
          await this.$nextTick()
          this.clearParentSelection()
          this.$message.success(res.data.msg || this.buildParentImportResultTitle(this.parentImportResult))
        } else {
          this.$message.error(res.data && res.data.msg || '导入失败')
        }
      } catch (e) {
        this.$message.error('导入失败')
      } finally {
        this.parentImporting = false
      }
    },
    teacherRowSelectable(row) {
      return !row.isAlreadyAdded
    },
    syncTeacherSelectedFromTable() {
      this.$nextTick(() => {
        const table = this.$refs.teacherTable
        if (!table) return
        this.teacherSelectedRows = table.selection ? [...table.selection] : []
      })
    },
    clearTeacherSelection() {
      this.teacherSelectedRows = []
      const table = this.$refs.teacherTable
      if (table) table.clearSelection()
    },
    refreshTeacherPreview() {
      this.teacherImportResult = null
      this.clearTeacherSelection()
      this.loadTeacherPreview()
    },
    async loadTeacherPreview() {
      if (!this.schoolId) return
      const requestId = ++this.teacherPreviewRequestId
      const requestPage = this.teacherPage
      this.teacherPreviewLoading = true
      try {
        const res = await previewTeacherVehicles({
          schoolId: this.schoolId,
          page: requestPage,
          pageSize: this.teacherPageSize,
          addedStatus: this.teacherAddedStatus,
          keyword: (this.teacherSearchKeyword || '').trim() || undefined
        })
        if (requestId !== this.teacherPreviewRequestId || requestPage !== this.teacherPage) return
        if (res.data && res.data.success) {
          const resp = res.data.response || {}
          const rows = resp.data || resp.Data || []
          this.teacherPreviewList = rows.map(r => ({
            plateNo: r.PlateNo || r.plateNo || '',
            ownerName: r.OwnerName || r.ownerName || '',
            mobile: r.Mobile || r.mobile || '',
            departmentName: r.DepartmentName || r.departmentName || '',
            isAlreadyAdded: r.IsAlreadyAdded != null ? r.IsAlreadyAdded : (r.isAlreadyAdded || false),
            existingVehicleId: r.ExistingVehicleId != null ? r.ExistingVehicleId : (r.existingVehicleId || null),
            sourceVehicleId: r.SourceVehicleId != null ? r.SourceVehicleId : (r.sourceVehicleId || null)
          }))
          this.teacherPreviewTotal = resp.dataCount != null ? resp.dataCount : (resp.DataCount || 0)
          const summary = resp.summary || resp.Summary
          if (summary) {
            this.teacherPreviewSummary = {
              totalCount: summary.TotalCount != null ? summary.TotalCount : (summary.totalCount || 0),
              pendingCount: summary.PendingCount != null ? summary.PendingCount : (summary.pendingCount || 0),
              addedCount: summary.AddedCount != null ? summary.AddedCount : (summary.addedCount || 0)
            }
          }
          this.syncTeacherSelectedFromTable()
        }
      } catch (e) {
        if (requestId === this.teacherPreviewRequestId) {
          this.$message.error('加载教师车牌失败')
        }
      } finally {
        if (requestId === this.teacherPreviewRequestId) {
          this.teacherPreviewLoading = false
        }
      }
    },
    quickFilterTeacherByStatus(status) {
      if (this.teacherAddedStatus === status) return
      this.teacherAddedStatus = status
      this.teacherPage = 1
      this.clearTeacherSelection()
      this.loadTeacherPreview()
    },
    handleTeacherSearch() {
      this.teacherPage = 1
      this.clearTeacherSelection()
      this.loadTeacherPreview()
    },
    handleTeacherPageChange(val) {
      this.teacherPage = val
      this.loadTeacherPreview()
    },
    handleTeacherSizeChange(size) {
      this.teacherPageSize = Math.min(size, 200)
      this.teacherPage = 1
      this.loadTeacherPreview()
    },
    onTeacherSelectionChange(rows) {
      this.teacherSelectedRows = rows
    },
    async confirmTeacherImport() {
      if (this.teacherSelectedRows.length === 0) return
      this.teacherImporting = true
      this.teacherImportResult = null
      try {
        const items = this.teacherSelectedRows.map(r => ({
          plateNo: r.plateNo,
          ownerName: r.ownerName,
          mobile: r.mobile,
          isAlreadyAdded: r.isAlreadyAdded,
          existingVehicleId: r.existingVehicleId || null,
          sourceVehicleId: r.sourceVehicleId || null
        }))
        const res = await importFromTeacherVehicles(this.schoolId, items)
        if (res.data && res.data.success) {
          const pr = res.data.response || {}
          this.teacherImportResult = {
            addedCount: pr.AddedCount !== undefined ? pr.AddedCount : pr.addedCount,
            updatedCount: pr.UpdatedCount !== undefined ? pr.UpdatedCount : pr.updatedCount,
            syncFailCount: pr.SyncFailCount !== undefined ? pr.SyncFailCount : pr.syncFailCount,
            pendingSyncCount: pr.PendingSyncCount != null ? pr.PendingSyncCount : (pr.pendingSyncCount || 0),
            batchSyncJobId: pr.BatchSyncJobId != null ? pr.BatchSyncJobId : (pr.batchSyncJobId || null)
          }
          this.loadData()
          this.loadActiveBatchSyncJob()
          await this.loadTeacherPreview()
          await this.$nextTick()
          this.clearTeacherSelection()
          this.$message.success(res.data.msg || this.buildParentImportResultTitle(this.teacherImportResult))
        } else {
          this.$message.error(res.data && res.data.msg || '导入失败')
        }
      } catch (e) {
        this.$message.error('导入失败')
      } finally {
        this.teacherImporting = false
      }
    },
    syncTagType(status) {
      if (status === 1) return 'success'
      if (status === 2) return 'danger'
      if (status === 3) return 'warning'
      return 'info'
    },
    sourceTagType(source) {
      if (source === 1) return 'warning'
      if (source === 2) return ''
      return 'success'
    },
    formatDate(val) {
      if (!val) return ''
      const d = new Date(val)
      if (isNaN(d.getTime())) return val
      const pad = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    }
  }
}
</script>

<style>
@import './parking-page.css';

/* 免费车页局部样式（通用布局见 parking-page.css） */

/* 车牌号微型徽章 - 带有精致蓝白微渐变，酷似真实蓝牌 */
.dp-layout .plate-no-badge {
  display: inline-block;
  padding: 4px 10px;
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  color: #1d4ed8;
  border: 1px solid #bfdbfe;
  border-radius: 6px;
  font-weight: bold;
  font-family: system-ui, -apple-system, sans-serif;
  font-size: 13px;
  box-shadow: 0 1px 2px rgba(29, 78, 216, 0.05);
}

/* 时间列等宽排版 */
.dp-layout .time-text {
  font-family: "Courier New", Courier, monospace;
  color: #334155;
  font-size: 13px;
  font-weight: 500;
}

/* 时间未发生占位符 */
.dp-layout .text-muted {
  color: #94a3b8;
  font-size: 13px;
}

/* 车主姓名与电话 */
.dp-layout .owner-name-text,
.dp-layout .mobile-text {
  font-size: 13px;
  color: #475569;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.dp-layout .owner-name-text i,
.dp-layout .mobile-text i {
  color: #94a3b8;
  font-size: 14px;
}

/* 来源标签美化 */
.dp-layout .source-tag {
  display: inline-block;
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 20px;
  font-weight: 600;
  border: 1px solid transparent;
}
.dp-layout .source-tag.source-0 { /* 手工录入 */
  color: #059669;
  background-color: #ecfdf5;
  border-color: #a7f3d0;
}
.dp-layout .source-tag.source-1 { /* 监护人导入 */
  color: #d97706;
  background-color: #fffbeb;
  border-color: #fde68a;
}
.dp-layout .source-tag.source-2 { /* Excel导入 */
  color: #2563eb;
  background-color: #eff6ff;
  border-color: #bfdbfe;
}
.dp-layout .source-tag.source-3 { /* 教师导入 */
  color: #7c3aed;
  background-color: #f5f3ff;
  border-color: #ddd6fe;
}

/* 同步状态标签美化 */
.dp-layout .sync-status-badge {
  display: inline-block;
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: 600;
  border: 1px solid transparent;
}
.dp-layout .sync-status-badge.status-0 { /* 待同步 */
  color: #4b5563;
  background-color: #f3f4f6;
  border-color: #e5e7eb;
}
.dp-layout .sync-status-badge.status-1 { /* 已下发 */
  color: #059669;
  background-color: #ecfdf5;
  border-color: #a7f3d0;
}
.dp-layout .sync-status-badge.status-2 { /* 下发失败 */
  color: #dc2626;
  background-color: #fef2f2;
  border-color: #fca5a5;
}
.dp-layout .sync-status-badge.status-3 { /* 待更新 */
  color: #d97706;
  background-color: #fffbeb;
  border-color: #fde68a;
}

/* 操作按钮组 */
.dp-layout .actions-group {
  display: flex;
  flex-wrap: wrap;
  gap: 2px 12px;
  align-items: center;
  max-width: 130px;
}
.dp-layout .actions-group .el-button {
  margin-left: 0 !important;
}

/* 新增/编辑弹窗布局 */
.edit-vehicle-dialog .vehicle-edit-layout {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}
.edit-vehicle-dialog .vehicle-edit-left {
  flex: 0 0 340px;
  min-width: 0;
}
.edit-vehicle-dialog .vehicle-edit-right {
  flex: 1;
  min-width: 0;
}
.edit-vehicle-dialog .plate-keyboard-wrap {
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  padding: 8px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,.08);
}

/* 导入/导出工具条 */
.import-vehicle-dialog .import-actions {
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
}
.import-vehicle-dialog .import-result {
  margin-top: 12px;
}
.import-vehicle-dialog .parent-preview-stat-cards {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 12px;
}
.import-vehicle-dialog .parent-preview-stat-cards.is-summary-loading {
  opacity: 0.65;
  pointer-events: none;
}
.import-vehicle-dialog .parent-preview-stat-card {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px 12px;
  background: #fff;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.import-vehicle-dialog .parent-preview-stat-card.clickable {
  cursor: pointer;
}
.import-vehicle-dialog .parent-preview-stat-card.clickable:hover {
  border-color: #cbd5e1;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
}
.import-vehicle-dialog .parent-preview-stat-card.active {
  border-color: #93c5fd;
  box-shadow: 0 0 0 1px #93c5fd, 0 2px 8px rgba(37, 99, 235, 0.1);
}
.import-vehicle-dialog .parent-preview-stat-card.stat-pending.active {
  border-color: #86efac;
  box-shadow: 0 0 0 1px #86efac, 0 2px 8px rgba(22, 163, 74, 0.1);
}
.import-vehicle-dialog .parent-preview-stat-card.stat-synced.active {
  border-color: #cbd5e1;
  box-shadow: 0 0 0 1px #cbd5e1, 0 2px 8px rgba(100, 116, 139, 0.08);
}
.import-vehicle-dialog .parent-preview-stat-card .stat-card-head {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
}
.import-vehicle-dialog .parent-preview-stat-card .stat-card-icon {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
}
.import-vehicle-dialog .parent-preview-stat-card.stat-total .stat-card-icon { background: #eff6ff; color: #2563eb; }
.import-vehicle-dialog .parent-preview-stat-card.stat-pending .stat-card-icon { background: #f0fdf4; color: #16a34a; }
.import-vehicle-dialog .parent-preview-stat-card.stat-synced .stat-card-icon { background: #f8fafc; color: #64748b; }
.import-vehicle-dialog .parent-preview-stat-card .stat-card-label {
  font-size: 12px;
  color: #64748b;
}
.import-vehicle-dialog .parent-preview-stat-card .stat-card-value {
  font-size: 20px;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.2;
}
.import-vehicle-dialog .hint-text {
  font-size: 12px;
  color: #909399;
}

/* 同步日志 */
.pagination-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  margin-top: 8px;
}
.sync-log-dialog .sync-log-detail-title,
.sync-log-detail-dialog .sync-log-detail-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 600;
}
.sync-log-detail-dialog .sync-log-detail {
  padding: 0 2px;
}
.sync-log-detail-dialog .sync-log-desc {
  margin-bottom: 14px;
}
.sync-log-detail-dialog .sync-log-detail-alert {
  margin-bottom: 14px;
}
.sync-log-detail-dialog .sync-log-response-block {
  margin-top: 4px;
}
.sync-log-detail-dialog .sync-log-response-hd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #303133;
}
.sync-log-detail-dialog .sync-log-pre {
  margin: 0;
  padding: 12px 14px;
  background: #282c34;
  color: #abb2bf;
  border-radius: 6px;
  font-family: Consolas, Monaco, 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.6;
  max-height: 240px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-all;
}
.sync-log-detail-dialog .sync-log-pre.is-empty {
  background: #f5f7fa;
  color: #909399;
  text-align: center;
}

/* 附加 Element UI 表格高级定制，带来圆角与卡片阴影感 */
.dp-layout .el-table {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03) !important;
  border: 1px solid #e2e8f0 !important;
}
.dp-layout .el-table th {
  background-color: #f8fafc !important;
  color: #475569 !important;
  font-weight: 600 !important;
}
.dp-layout .el-table__row:hover > td {
  background-color: #f8fafc !important;
}

.sync-log-dialog .el-dialog__body {
  padding-bottom: 10px;
}
.sync-log-dialog .sync-log-body {
  position: relative;
}
.sync-log-detail-dialog .el-dialog__body {
  padding-top: 12px;
}
</style>
